<template>
  <div class="main_right">
    <div class="Box">
<!--      <div class="imgs">-->
<!--        <div class="img4 img">-->
<!--          <p><span style="font-size: 18px">错词来源</span></p>-->
<!--    -->
<!--        </div>-->
<!--      </div>-->
      <div style="display: flex;justify-content: start;align-items: center;">
        <p style="padding-right: 10px">错词来源</p>
        <el-select v-model="source" placeholder="请选择集训来查询数据" class="selsectbox">
          <el-option v-for="item in options" :key="item.jxid" :label="item.jxmc" :value="item.jxid"/>
        </el-select>
      </div>
      <div class="testpage" style="height:calc(100% - 2vw);">
        <el-table ref="table" class="table" :data="tableData" border
                  :header-cell-style="{background:'#F1F8FF',color:'#333','text-align':'center'}">
          <el-table-column align="center" width="80" label="序号">
            <template v-slot="scope">
              {{ (pages.currentPage - 1) * pages.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="dcmc" align="center" show-overflow-tooltip label="单词名称"/>
          <el-table-column prop="lxmc" align="center" show-overflow-tooltip label="类型名称"/>
          <el-table-column prop="bbmc" align="center" show-overflow-tooltip label="版本名称"/>
          <el-table-column prop="zmc" align="center" show-overflow-tooltip label="章名称"/>
          <el-table-column prop="dymc" align="center" show-overflow-tooltip label="单元名称"/>
        </el-table>

        <div class="page">
          <el-pagination @size-change="stuHandleSizeChange" @current-change="stuHandleCurrentChange"
                         :current-page="pages.currentPage" :page-sizes="[10, 20, 30, 40]"
                         :page-size="pages.pageSize" layout="total, sizes, prev, pager, next"
                         :total="pages.total">
          </el-pagination>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import {getTrains, getFamiliarWord} from '@/api/student'

export default {
  data() {
    return {
      value1: '',
      tableData: [],
      source: null, // 错词来源
      options: [],
      pages: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
    }
  },
  created() {
    // this.myCollectionWord()
    getTrains({yhid: this.$store.state.userInfo.yhid, yycdid: this.$store.state.yycdid}).then(res => {
      if (res.success) {
        if (res.result.length) {
          this.options = res.result
          this.source = this.options[0].jxid
          this.getFamiliar()
        } else {
          this.$message.warning('未参加集训，暂无数据')
        }
      } else {
        this.$message.error(res.resultDesc)
      }
    })
    this.getFamiliar()
  },
  methods: {
    // 获取熟词信息
    async getFamiliar() {
      const {result: {list, total}, resultCode} = await getFamiliarWord({
        currentPage: this.pages.currentPage,
        pageSize: this.pages.pageSize,
        jxid: this.source,
        xsid: this.$store.state.userInfo.yhid,
      })
      if (resultCode === 200) {
        this.tableData = list
        this.pages.total = total
      }
    },
    stuHandleSizeChange(val) {
      this.pages.pageSize = val;
      this.pages.currentPage = 1;
      this.getFamiliar()
    },
    stuHandleCurrentChange(val) {
      this.pages.currentPage = val;
      this.getFamiliar()
    },
  },

}
</script>
<style lang="scss" scoped>
.main_right {
  width: calc(100% - 10.5vw);
  height: 100%;
  float: left;
  box-sizing: border-box;
  padding: 0 2%;
  position: relative;

  .Box {
    width: 100%;
    height: 100%;
    box-shadow: 0px 0px 16px 0px rgba(89, 144, 255, 0.3);
    border-radius: 10px;
    padding: 2%;
    box-sizing: border-box;
    position: relative;
  }


  .vocabulary {
    width: 30%;
    height: 3vw;
    float: left;

    div {
      width: 14vw;
      height: 3vw;
      background: #F1F8FF;
      border-radius: 10px;
      line-height: 3vw;
      box-sizing: border-box;
      padding: 0 3%;
      color: #333;

      span {
        display: block;
      }

      span:nth-child(1) {
        // display: block;
        font-size: 1.1vw;
        float: left;
      }

      p {
        float: right;

        span:nth-child(1) {
          font-size: 1.5vw;
          color: #409EFF;
          font-weight: 600;
          float: left;
          margin-right: 1.5vw;
        }

        span:nth-child(2) {
          font-size: 1vw;
          float: left;
        }
      }
    }
  }

  .testpage {
    width: 100%;
    height: 100%;
    position: relative;

    p:nth-child(1) {
      width: 100%;
      height: 2.5vw;
      text-align: center;
      position: relative;
      color: #333;
      font-size: 1.5vw;
      line-height: 2.5vw;
    }
  }

  .page {
    position: absolute;
    bottom: 5px;
    right: 0;
  }

  .table {
    overflow-y: auto;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 4vw;
    top: 2vw;
  }

  .aRow {
    width: 100%;
    height: 3vw;
  }

  .aRow:after { /*伪元素是行内元素 正常浏览器清除浮动方法*/
    content: "";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }

  .btn {
    width: 7vw;
    height: 2.5vw;
    color: #fff;
    background: #5990FF;
    font-size: 1.1vw;
    text-align: center;
    line-height: 2.5vw;
    border-radius: 32px;
    position: absolute;
    bottom: 2vw;
    left: 50%;
    transform: translateX(-50%);
    cursor: pointer;
  }

  .remove {
    width: 5vw;
    height: 2vw;
    font-size: .8vw;
    background: #E0EAFF;
    border-radius: 21px;
    color: #5990FF;
    text-align: center;
    line-height: 2vw;
    display: inline-block;
    cursor: pointer;
  }
}
/* ========== 手机端适配样式 ========== */
@media screen and (max-width: 768px) {
  .main_right {
    width: calc(100% - 90px);
    padding: 0 10px;

    .Box {
      padding: 15px 10px;
      display: flex;
      flex-direction: column;

      > div:first-child {
        margin-bottom: 15px;
        flex-wrap: wrap;

        p {
          font-size: 14px;
          padding-right: 10px;
          margin-bottom: 10px;
        }

        .selsectbox {
          width: 100%;
        }
      }
    }

    .testpage {
      flex: 1;
      min-height: 0;
      display: flex;
      flex-direction: column;

      .table {
        position: relative;
        top: auto;
        bottom: auto;
        flex: 1;
        overflow: auto;
      }
    }

    .page {
      position: relative;
      bottom: auto;
      right: auto;
      //margin-top: 15px;
      display: flex;
      justify-content: flex-end;

      ::v-deep  .el-pagination {
        .btn-prev, .btn-next {
          padding: 0 8px;
        }

        .el-pager li {
          min-width: 28px;
          height: 28px;
          line-height: 28px;
          font-size: 12px;
        }
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .main_right {
    width: calc(100% - 70px);
    padding: 0 8px;

    .Box {
      padding: 12px 8px;
    }

    .page {
      ::v-deep  .el-pagination {
        .el-pagination__total {
          font-size: 11px;
        }

        .el-pagination__sizes {
          .el-select .el-input__inner {
            font-size: 11px;
            height: 28px;
            line-height: 28px;
          }
        }

        .btn-prev, .btn-next {
          padding: 0 6px;
          min-width: 28px;
        }

        .el-pager li {
          min-width: 24px;
          height: 24px;
          line-height: 24px;
          font-size: 11px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.el-table {
  font-size: .9vw;
}
@media screen and (max-width: 768px) {
  .el-table {
    font-size: 12px;

    .el-table__header th {
      font-size: 12px;
    }

    .el-table__body td {
      font-size: 11px;
    }
  }
}

@media screen and (max-width: 480px) {
  .el-table {
    font-size: 10px;

    .el-table__header th {
      font-size: 10px;
      padding: 8px 0;
    }

    .el-table__body td {
      font-size: 9px;
      padding: 6px 0;
    }
  }
}
</style>
